import Axios from "axios";
import {
    SET_ASSET_ASSIGNMENTS_LIST,
    UNSET_ASSET_ASSIGNMENTS_LIST,
} from "@/store/mutation-types";

import { saveUpdateAssetAssignment, saveUpdateAssetUnassignment, getAssetAssignmentsList, getAssetAssignmentById } from "@/store/api";

const state = {
    getAssetAssignmentsList: [],
    getEditingAssetAssignment: null,
};

const getters = {
    getAssetAssignmentsList(state) {
        return state.getAssetAssignmentsList;
    },
};

const mutations = {
    [SET_ASSET_ASSIGNMENTS_LIST](state, data) {
        state.getAssetAssignmentsList = data;
    },
    [UNSET_ASSET_ASSIGNMENTS_LIST](state) {
        state.getAssetAssignmentsList = [];
    },
};

const actions = {
    saveUpdateAssetAssignment({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateAssetAssignment, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    saveUpdateAssetUnassignment({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateAssetUnassignment, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getAssetAssignmentsList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getAssetAssignmentsList, { params: data})
                .then(function (response) {
                    commit('SET_ASSET_ASSIGNMENTS_LIST', response.data.data)
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_ASSET_ASSIGNMENTS_LIST')
                    reject(error);
                })
                .then((always) => {
                });
        });
    },

    getAssetAssignmentById({ commit }, data) {
        const getAssetAssignmentsById = `${getAssetAssignmentById}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(getAssetAssignmentsById)
                    .then((response) => {
                    resolve(response.data); 
                })
                    .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                    .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
